/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import { AuthProvider } from "./AuthContext";
import { checkAppVersion } from "./versionCheck";

checkAppVersion();

const root = createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
